import { SubscriptionManagementApiService } from './service';
import ApiClientFactory from '../../../api/client-factory';

const service = new SubscriptionManagementApiService(ApiClientFactory());

export function SubscriptionManagementApiServiceFactory(): typeof service {
  return service;
}
